/**
 * Authentication configuration
 * Controls which authentication methods are enabled in the UI
 */

const getOptionalEnv = (name, fallback = '') => {
  const value = process.env[name];
  if (typeof value === 'string' && value.trim()) return value.trim();
  return fallback;
};

// Set to false to disable email/password authentication
// When disabled, email login and signup forms will be hidden but code remains intact
// Can be controlled via REACT_APP_ENABLE_EMAIL_AUTH environment variable (defaults to false)
export const ENABLE_EMAIL_AUTH = process.env.REACT_APP_ENABLE_EMAIL_AUTH === 'true' || false;

// OAuth connection names for Auth0
// These should match the connection names configured in your Auth0 dashboard
export const OAUTH_CONNECTIONS = {
  GOOGLE: getOptionalEnv('REACT_APP_AUTH0_CONNECTION_GOOGLE', 'google-oauth2'),
  GITHUB: getOptionalEnv('REACT_APP_AUTH0_CONNECTION_GITHUB', 'github'),
  APPLE: getOptionalEnv('REACT_APP_AUTH0_CONNECTION_APPLE', 'apple'),
  MICROSOFT: getOptionalEnv('REACT_APP_AUTH0_CONNECTION_MICROSOFT')
};

export const HAS_SOCIAL_AUTH = Object.values(OAUTH_CONNECTIONS).some(Boolean);
